"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import {
  identifyClarityAnonymous,
  syncClarityIntoMixpanel,
} from "@/lib/services/ClarityMixpanelBridge";
import { useAuth } from "./supabase-auth-provider";

export function ClarityIdentityProvider() {
  const pathname = usePathname();
  const { user } = useAuth();

  useEffect(() => {
    const path = pathname ?? "/";

    if (user?.id) {
      // Authenticated: stamp real user ID onto Clarity + Mixpanel super props.
      // clarity_custom_user_id will always match Mixpanel's user_id.
      syncClarityIntoMixpanel(user.id, path);
    } else {
      // Anonymous: tell Clarity about the session for recording purposes,
      // but do NOT write a device ID into Mixpanel's clarity_custom_user_id.
      identifyClarityAnonymous(path);
    }
  }, [pathname, user?.id]);

  return null;
}
